// Compat shim for @intrasync/utils 26.x.
//
// The 26.x package splits its API into individual named exports plus a `utils`
// aggregate namespace, but that aggregate dropped a few members this app accesses
// as `utils.x` (e.g. `uuid`, `clearBrowserCache`). The app has ~77 files using
// `import { utils } from "@intrasync/utils"` and calling `utils.uuid()` etc.
//
// Rather than rewrite every call site, this shim re-exports everything from the
// real package and rebuilds a COMPLETE `utils` aggregate from all named exports.
// Vite aliases the bare `@intrasync/utils` specifier to this file; the real
// package is reached via the `@intrasync/utils-pkg` alias (see vite.config.ts).
//
// @ts-nocheck - resolved at build time via Vite alias, not by tsc.
import * as pkg from "@intrasync/utils-pkg";
// `productTypeKeys` is app-specific and was never part of the generic package,
// but is accessed as `utils.productTypeKeys` in a few places.
import productTypeKeys from "shared/common/utils/productTypeKeys";

export * from "@intrasync/utils-pkg";

// Explicit `utils` export overrides the star-exported aggregate, merging the
// package aggregate with all top-level named exports so dropped members
// (uuid, clearBrowserCache, …) are present.
export const utils = {
  ...(pkg.utils ?? {}),
  ...pkg,
  productTypeKeys,
};
